/* @jsx h */
import { defineComponent, h } from "vue";
import {} from "vue-router";

export const Navbar = defineComponent({
  name: "Navbar",
  setup() {
    return () => {
      return null;
      //      return (
      //        <div class="bg-[--body-bg-color] flex flex-col">
      //          <div class="flex flex-1">
      //            <RouterLink
      //              to="/"
      //              class="pl-4 text-white flex justify-center items-center text-2xl"
      //            >
      //              {<img style="height: 25px;" src={lemmonLogo} />}
      //              {import.meta.env.VITE_ENV === "production" ? null : (
      //                <div class="text-xs uppercase badge badge-warning ml-3">
      //                  {import.meta.env.VITE_ENV}
      //                </div>
      //              )}
      //            </RouterLink>
      //            <div class="flex justify-between h-16 flex-1"></div>
      //            {auth.user.value && (
      //              <div class="pr-2 flex justify-center items-center">
      //                <div class="px-2 flex-col">
      //                  <div class="text-white">
      //                    Hey, {auth.user.value.profile.name.split(" ")[0]}
      //                  </div>
      //                  <div class="text-xs">{`${auth.user.value.restaurant.name}`}</div>
      //                </div>
      //                <a class="hover:text-white" href="#" onClick={handleLogout}>
      //                  <span class="material-symbols-outlined mr-1 text-3xl">
      //                    logout
      //                  </span>{" "}
      //                </a>
      //              </div>
      //            )}
      //          </div>
      //          <div class="border-b border-gray-700" />
      //        </div>
      //      );
    };
  },
});
